module.exports = __webpack_public_path__ + "files/0ceaa0c7df9695e924495e65388c2c66.png";